// App Store

const state = {
  error: null,
}

const getters = {}

const actions = {
  clearError({ commit }) {
    commit('CLEAR_ERROR')
  },
  setError({ commit }, error) {
    commit('SET_ERROR', error)
  },
}

const mutations = {
  CLEAR_ERROR: state => {
    state.error = null
  },
  SET_ERROR: (state, error) => {
    state.error = error
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
